import storage from '../../../hooks/useStorage/useStorage';

const MAX_TRY_COUNT = 15;

export const waitOfflineEncryptionKey = async () => {
  const teamId = storage.getTeamId();

  const encryptionKeyFromStorage = teamId ? storage.getOfflineEncryptionKey(teamId) : undefined;

  if (!encryptionKeyFromStorage) {
    let tryCount = 0;

    return new Promise<void>((resolve, reject) => {
      const intervalId = setInterval(() => {
        const updatedEncryptionKeyFromStorage = teamId
          ? storage.getOfflineEncryptionKey(teamId)
          : undefined;

        if (updatedEncryptionKeyFromStorage) {
          clearInterval(intervalId);
          resolve();
          return;
        }

        if (tryCount >= MAX_TRY_COUNT) {
          clearInterval(intervalId);
          reject(new Error('timeout waiting for offline encryption key'));
          return;
        }

        tryCount += 1;
      }, 1000);
    });
  }

  return Promise.resolve();
};
